import Vue from "vue";
const uuit = {
  getToken() {
    try {
      if (sessionStorage.getItem("token")) {
        Vue.prototype.$role = JSON.parse(sessionStorage.getItem("token"));
      } else {
        Vue.prototype.$role = null;
      }
    } catch (error) {
      sessionStorage.clear();
      sessionStorage.clear();
    }
  }
};
export default uuit;
